import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainNav from '../components/main-nav-view';
import {
  meId,
  meProducts,
  meIsAccountAdmin,
  meUserName,
  meDisplayName,
  meNewAvatarImageSource,
  meSupportExperience,
  meLocale,
} from 'modules/me-module';
import auth from 'lib/profile-auth';
import environment from 'lib/environment';
import { billingMeRequestGet, meIsBillingAdmin } from 'modules/billing-module';
import { mtgServiceSettingsGet, gotoAppEnabled  } from 'modules/meeting-module';
import appconfig from 'config/appconfig';
import { getSupportExperienceUrls } from 'lib/utility-functions';

export class MainNavContainer extends Component {
  componentDidMount = () => {
    this.props.billingMeRequestGet();
    if (this.props.myProducts.indexOf("g2m") > -1 || this.props.myProducts.indexOf("g2mfree") > -1) {
      this.props.mtgServiceSettingsGet();
    }
  };

  render() {
    return (
      <MainNav
        logout={this.props.logout}
        displayName={this.props.displayName}
        meIsAccountAdmin={this.props.meIsAccountAdmin}
        myProducts={this.props.myProducts}
        avatarImageUrl={this.props.avatarImageUrl}
        meIsBillingAdmin={this.props.meIsBillingAdmin}
        personalInfoSelectedClass={this.props.currentPath === appconfig.routes.personalInfo() ? 'selected' : ''}
        signInSecuritySelectedClass={this.props.currentPath === appconfig.routes.signinSecurity() ? 'selected' : ''}
        displayEmail={this.props.displayEmail}
        showSupportLink={this.props.supportExperience !== appconfig.supportExperiences.HIDE}
        supportUrls={getSupportExperienceUrls(this.props.supportExperience)}
        gotoAppEnabled={this.props.gotoAppEnabled}
        language={this.props.language}
      />
    );
  }
}

MainNavContainer.propTypes = {
  logout: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
  meIsAccountAdmin: PropTypes.bool.isRequired,
  myProducts: PropTypes.array.isRequired,
  avatarImageUrl: PropTypes.string.isRequired,
  billingMeRequestGet: PropTypes.func.isRequired,
  mtgServiceSettingsGet: PropTypes.func.isRequired,
  meIsBillingAdmin: PropTypes.bool.isRequired,
  currentPath: PropTypes.string.isRequired,
  displayEmail: PropTypes.string.isRequired,
  supportExperience: PropTypes.string,
  gotoAppEnabled: PropTypes.bool.isRequired,
  language: PropTypes.string,
};

export const mapStateToProps = (state) => {
  // Adding a default value for environment.get().avatar_image_url,
  //   because during unit testing a false warning message is thrown without it.
  const avatarBaseImageUrl = environment.get().avatar_image_url || '';
  let avatarImageUrl = avatarBaseImageUrl.length ? `${avatarBaseImageUrl}${meId(state)}_medium.jpg` : '';

  // Check if the user has uploaded a new avatar image during the session.
  //   If he/she did, use the URL of that image as a source for the mini avatar.
  const newAvatarImage = meNewAvatarImageSource(state);
  if (newAvatarImage) {
    avatarImageUrl = newAvatarImage;
  }

  return {
    logout: auth.logout.bind(auth),
    myProducts: meProducts(state),
    displayName: meDisplayName(state) || '',
    avatarImageUrl,
    meIsBillingAdmin: meIsBillingAdmin(state),
    meIsAccountAdmin: meIsAccountAdmin(state),
    currentPath: '',
    displayEmail: meUserName(state) || '',
    supportExperience: meSupportExperience(state) || appconfig.supportExperiences.DEFAULT,
    gotoAppEnabled: gotoAppEnabled(state),
    language: meLocale(state) ? meLocale(state).split("_")[0].toLowerCase() : 'en',
  };
};

export const mapDispatchToProps = dispatch => ({
  billingMeRequestGet: () => dispatch(billingMeRequestGet(true)),
  mtgServiceSettingsGet: () => dispatch(mtgServiceSettingsGet(true)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainNavContainer);
